/* Product page videos: vertical poster in the square gallery slide, and a full-screen vertical player
   (YouTube or Shopify video) with price + ORDER NOW (COD) when the video is tapped. */
(() => {
  if (window.BBPV) return;
  window.BBPV = true;
  const ytId = (src) => { const m = String(src || '').match(/(?:embed\/|youtu\.be\/|v=|shorts\/)([\w-]{6,})/); return m ? m[1] : ''; };

  function source(dm) {
    const tpl = dm.querySelector('template');
    const frag = tpl ? tpl.content : dm;
    const ifr = frag.querySelector('iframe');
    if (ifr && /youtube/.test(ifr.src)) return { yt: ytId(ifr.src) };
    const v = frag.querySelector('video');
    if (v) return { video: v };
    return null;
  }

  function overlay() {
    let o = document.getElementById('bbpv');
    if (o) return o;
    o = document.createElement('div');
    o.id = 'bbpv';
    o.className = 'bbpv';
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.setAttribute('aria-label', 'Product video');
    const price = document.querySelector('.bb-sticky [data-sticky-price], .bb-price__now');
    const order = document.querySelector('[data-order]');
    o.innerHTML = `<div class="bbpv-box"><button type="button" class="bbpv-x" aria-label="Close video">✕</button><div class="bbpv-player"></div>
      ${order ? `<div class="bbpv-bar"><div><b>${price ? price.textContent.trim() : ''}</b><small>✅ Cash on Delivery</small></div><button type="button" class="bbpv-go">ORDER NOW (COD) ➜</button></div>` : ''}</div>`;
    document.body.appendChild(o);
    const close = () => { o.classList.remove('is-open'); o.querySelector('.bbpv-player').innerHTML = ''; document.documentElement.classList.remove('bbpv-lock'); };
    o.addEventListener('click', (e) => {
      if (e.target === o || e.target.closest('.bbpv-x')) close();
      if (e.target.closest('.bbpv-go')) { close(); const b = document.querySelector('[data-order]'); if (b) b.click(); }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && o.classList.contains('is-open') && !document.documentElement.classList.contains('bbcod-open')) close(); });
    return o;
  }

  function open(src) {
    // the product page videos section (assets/bb-watch.js) plays it in the full-screen Shorts-style player
    if (window.BBW2open && window.BBW2open(src)) return;
    const o = overlay(), box = o.querySelector('.bbpv-player');
    if (src.yt) {
      box.innerHTML = `<iframe src="https://www.youtube-nocookie.com/embed/${src.yt}?autoplay=1&playsinline=1&rel=0&modestbranding=1&iv_load_policy=3" title="Product video" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
    } else {
      const v = src.video.cloneNode(true);
      v.controls = true; v.autoplay = true; v.muted = false; v.playsInline = true; v.removeAttribute('preload');
      box.innerHTML = ''; box.appendChild(v);
      v.play().catch(() => {});
    }
    o.classList.add('is-open');
    document.documentElement.classList.add('bbpv-lock');
  }

  function init() {
    document.querySelectorAll('.product-media deferred-media, media-gallery deferred-media').forEach((dm) => {
      if (dm.dataset.bbpv) return;
      const src = source(dm);
      if (!src) return;
      dm.dataset.bbpv = '1';
      dm.classList.add('bbpv-dm');
      // our own clean poster over the theme's (no giant play circle / blurred duplicates)
      const themeImg = dm.querySelector('img');
      const posterSrc = src.yt ? `https://i.ytimg.com/vi/${src.yt}/oar2.jpg` : ((src.video && src.video.getAttribute('poster')) || (themeImg && themeImg.src) || '');
      const fallback = src.yt ? `https://i.ytimg.com/vi/${src.yt}/hqdefault.jpg` : '';
      const pv = document.createElement('div');
      pv.className = 'bbpv-poster';
      pv.innerHTML = '<span class="bbpv-bg"></span><img alt="" loading="lazy"><span class="bbpv-play" aria-hidden="true">▶</span><span class="bbpv-tag">▶ Watch video</span>';
      const im = pv.querySelector('img'), bg = pv.querySelector('.bbpv-bg');
      const setSrc = (u) => { im.src = u; bg.style.backgroundImage = `url("${u}")`; };
      im.onerror = () => { if (fallback && im.src !== fallback) setSrc(fallback); };
      if (posterSrc) setSrc(posterSrc);
      dm.appendChild(pv);
      dm._bbpv = src;
    });
  }
  // window capture runs before the theme's own click handlers (zoom dialog, inline player)
  const grab = (e) => {
    const dm = e.target.closest && e.target.closest('deferred-media.bbpv-dm');
    if (!dm || !dm._bbpv) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (e.type === 'click') open(dm._bbpv);
  };
  window.addEventListener('click', grab, true);
  window.addEventListener('pointerup', grab, true);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  let pending = false;
  new MutationObserver(() => { if (pending) return; pending = true; requestAnimationFrame(() => { pending = false; init(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
